import {
  AddIcon,
  Alert,
  Button,
  Card,
  EmptyState,
  SettingsIcon,
} from '@all-manager/design-system-v2';
import FullPageLayout from '../../../layout/FullPageLayout/FullPageLayout';
import QuoteColumnsDialog from '../components/QuoteColumnsDialog/QuoteColumnsDialog';
import QuoteComparison from '../components/QuoteComparison/QuoteComparison';
import QuoteComparisonSkeleton from '../components/QuoteComparison/QuoteComparisonSkeleton';
import QuoteFormDialog from '../components/QuoteFormDialog/QuoteFormDialog';
import { useQuoteGroupPage } from './useQuoteGroupPage';

export default function QuoteGroupPage() {
  const hook = useQuoteGroupPage();
  const title = hook.group?.name ?? 'Comparaison de devis';

  return (
    <>
      <FullPageLayout
        htmlTitle={`Comparaisons devis | ${title}`}
        title={title}
        subtitle={hook.subtitle}
        backLink={hook.listPath}
        action={hook.isAdmin && hook.group ? (
          <>
            <Button variant="outlined" size="small" startIcon={<SettingsIcon />} onClick={hook.handleOpenColumns}>
              Critères
            </Button>
            {hook.quotes.length > 0 ? (
              <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={hook.handleOpenQuoteForm}>
                Nouveau devis
              </Button>
            ) : null}
          </>
        ) : undefined}
      >
        {hook.isError ? (
          <Alert
            severity="error"
            action={(
              <Button variant="text" size="small" color="inherit" onClick={hook.handleRetry}>
                Réessayer
              </Button>
            )}
          >
            Les devis n'ont pas pu être chargés. Vérifiez votre connexion puis réessayez.
          </Alert>
        ) : hook.isNotFound ? (
          <Card>
            <EmptyState
              title="Comparaison introuvable"
              subtitle="Elle a peut-être été supprimée, ou le lien est incomplet."
              action={(
                <Button variant="text" size="small" color="default" onClick={hook.handleBackToList}>
                  Revenir aux comparaisons
                </Button>
              )}
            />
          </Card>
        ) : hook.isGroupLoading || hook.isContentLoading ? (
          <QuoteComparisonSkeleton />
        ) : hook.quotes.length === 0 ? (
          <Card>
            <EmptyState
              title="Aucun devis à comparer"
              subtitle={hook.isAdmin
                ? 'Ajoutez les devis reçus : leurs montants et conditions s\'aligneront critère par critère.'
                : 'Les devis apparaîtront ici dès qu\'un administrateur les aura ajoutés.'}
              action={hook.isAdmin ? (
                <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={hook.handleOpenQuoteForm}>
                  Ajouter un devis
                </Button>
              ) : undefined}
            />
          </Card>
        ) : hook.visibleColumnCount === 0 ? (
          <Card>
            <EmptyState
              title="Aucun critère affiché"
              subtitle="Affichez ou ajoutez des critères pour comparer les devis."
              action={hook.isAdmin ? (
                <Button variant="text" size="small" color="default" onClick={hook.handleOpenColumns}>
                  Gérer les critères
                </Button>
              ) : undefined}
            />
          </Card>
        ) : (
          <QuoteComparison
            groupId={hook.groupId}
            columns={hook.columns}
            quotes={hook.quotes}
            isAdmin={hook.isAdmin}
          />
        )}
      </FullPageLayout>

      {hook.isQuoteFormOpen ? (
        <QuoteFormDialog groupId={hook.groupId} columns={hook.columns} onClose={hook.handleCloseQuoteForm} />
      ) : null}

      {hook.isColumnsOpen ? (
        <QuoteColumnsDialog groupId={hook.groupId} columns={hook.columns} onClose={hook.handleCloseColumns} />
      ) : null}
    </>
  );
}
